<template>

    <Head :title="title"></Head>

    <div class="h-screen w-screen flex bg-grey"
        id="app_layout">

        <Banner />


        <HeaderDesktop class="hidden lg:flex"
            @logout="logout"
        />


        <HeaderResponsive class="block lg:hidden"
            @logout="logout"
        />


        <div class="overflow-x-hidden overflow-y-scroll"
            style="
                width: calc(100vw - var(--sidebar-width));
                height: calc(100vh - var(--sidebar-height));
                margin-top: var(--sidebar-height);
            ">

            <main id="app-container" class="p-2 py-8 lg:px-4"
                style="max-width: 1280px;width:100%;margin-left: auto;margin-right:auto;">

                <slot></slot>

            </main>

        </div>


    </div>

</template>

<script>

import { defineComponent } from 'vue';
import Banner from '@/Components/Banner.vue';
import Dropdown from '@/Components/Dropdown.vue';
import DropdownLink from '@/Components/DropdownLink.vue';
import NavLnk from '@/Components/NavLink.vue';
import ResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import Link from '@/Components/Link.vue';
import { Head } from '@inertiajs/inertia-vue3';
import HeaderDesktop from "./Partials/HeaderDesktop";
import HeaderResponsive from "./Partials/HeaderResponsive";


export default defineComponent({

    props: {
        title: String,
    },

    components: {
        HeaderResponsive,
        HeaderDesktop,
        Head,
        Banner,
        Dropdown,
        DropdownLink,
        NavLnk,
        ResponsiveNavLink,
        Link
    },


    data() {
        return {
            showingNavigationDropdown: false,
        }
    },


    mounted() {

        this.init_one_signal();

    },


    methods: {

        logout() {
            this.$inertia.post(route('logout'));
        },

    }
});

</script>

<style>

:root {
    --sidebar-width: 0px;
    --sidebar-height: 70px;
    --sidebar-icon-length: 26px!important;
}

@media (min-width: 768px) {

    :root {
        --sidebar-height: 110px;
        --sidebar-icon-length: 40px!important;
    }

}

@media (min-width: 1024px) {

    :root {
        --sidebar-width: 200px;
        --sidebar-height: 0px;
    }

}


@media (min-width: 1920px) {

    :root {
        --sidebar-width: 280px;
    }

}

</style>
